import { makeAPIRequest } from "../helpers/apiCall";

/**
 * Retrieves all hubs based on the provided parameters.
 *
 * @param {Object} params - An object containing key-value pairs used as query parameters for the API request.
 * @returns {Promise<any>} A promise that resolves to the response data from the API.
 */
function getAllHubs(params: {
  [key: string]: string | number | boolean | Date | undefined;
}) {
  return makeAPIRequest({
    url: "/settings/hue/bridges",
    params,
    method: "get",
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
}

/**
 * Creates a new user by making an API request.
 *
 * @param params An object containing user parameters, where the key is the parameter name and the value can be a string, number, boolean, Date, or undefined.
 * @returns The data returned from the API response.
 */
function createUser(params: {
  [key: string]: string | number | boolean | Date | undefined;
}) {
  return makeAPIRequest({
    url: "/settings/hue/user",
    params,
    method: "post",
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
}

/**
 * Retrieves URL data based on the provided parameters.
 *
 * @param params - An object containing query parameters with keys representing parameter names and values of type string, number, boolean, Date, or undefined.
 * @returns The data property from the API response.
 */
function getURL(params: {
  [key: string]: string | number | boolean | Date | undefined;
}) {
  return makeAPIRequest({
    url: "/settings/hue/start",
    params,
    method: "post",
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
}

/**
 * Retrieves all zones from the API based on the provided parameters.
 *
 * @param {Object} params An object containing key-value pairs used as query parameters.
 * @returns {Promise<any>} A promise that resolves with the data from the API response.
 */
function getAllZones(params: {
  [key: string]: string | number | boolean | Date | undefined;
}) {
  return makeAPIRequest({
    url: "/settings/hue/zones",
    params,
    method: "get",
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
}

export const hueService = {
  getURL,
  getAllZones,
  getAllHubs,
  createUser,
};
